const eventTypes = {
  ALERT: 'alert',
  SCHEDULE: 'schedule',
  HOLIDAY: 'holiday',
}

export default eventTypes
